import {animate, motion, useMotionValue} from "framer-motion";
import {useNavigate} from 'react-router';
import React, {useCallback, useState, useEffect} from 'react';
import {AccessBtnComponent} from '../access-btn.component';

const isMobile = window.innerWidth <= 860;

export function GridCardComponent({prop, isInCenter}: { prop: any, isInCenter?: boolean }) {
    const navigate = useNavigate();
    const rotateX = useMotionValue(0);
    const rotateY = useMotionValue(0);
    const [isHovered, setIsHovered] = useState(isInCenter || false);
    const [currentImageIndex, setCurrentImageIndex] = useState(1);
    const [carouselInterval, setCarouselInterval] = useState<NodeJS.Timeout | null>(null);
    const [loading, setLoading] = useState(true); // Track loading state


    const handleMouseLeave = useCallback(() => {
        animate(rotateX, 0, {duration: 0.3});
        animate(rotateY, 0, {duration: 0.3});
        setIsHovered(false);
        setCurrentImageIndex(0);
        if (carouselInterval) {
            clearInterval(carouselInterval);
            setCarouselInterval(null);
        }
    }, [rotateX, rotateY, carouselInterval]);

    const handleMouseEnter = () => {
        setIsHovered(true);
        // const interval = setInterval(() => {
        //     setCurrentImageIndex((prevIndex) => (prevIndex + 1) % prop.images.length);
        // }, 1500); // Change image every 1 second
        // setCarouselInterval(interval);
    };

    useEffect(() => {
        return () => {
            if (carouselInterval) {
                clearInterval(carouselInterval);
            }
        };
    }, [carouselInterval]);

    useEffect(() => {
        if (isInCenter) {
            handleMouseEnter();
        } else {
            handleMouseLeave();
            if (carouselInterval) {
                clearInterval(carouselInterval);
            }
        }
    }, [isInCenter]);


    return (
        <motion.section
            className={`w-full rounded-lg flex flex-col items-center text-center relative ${(isMobile && isInCenter) ? 'scale-105' : ''}`}
            initial="hidden"
            whileInView="show"
            whileHover="hover"
            viewport={{once: true}}
            transition={{duration: 0.5}}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}

        >

            {isHovered && (<motion.div
                className="absolute w-md m-auto max-h-80 inset-0 rounded-full bg-gradient-to-r from-pink-200 via-purple-500 to-blue-500 opacity-30 blur-xl scale-95 group-hover:scale-100 transition-all duration-500"
                initial={{opacity: 0, scale: 0.95}}
                whileInView={{opacity: 1, scale: 1}}
            />)}
            <motion.div
                className={`group ${isMobile ? (isInCenter ? 'saturate-150' : 'saturate-150') : 'hover:saturate-150 saturate-0'} transition-[filter] relative w-full h-[285px] ${(isMobile && isInCenter) ? 'scale-110' : ''}`}
                initial={{scale: 1}}
                whileHover={isMobile ? {} : {scale: 1.03}}
                transition={{type: "spring", stiffness: 300, damping: 20}}
            >

                {loading && (
                    <div className="w-full h-full bg-gray-500 animate-pulse"></div>
                )}
                {/* Image with border-radius transition */}
                <img
                    alt={prop.title}
                    className={`w-md m-auto max-h-80 group-hover:rounded-br-[0px] transition-[border-radius] ${(isMobile && isInCenter) ? 'scale-110' : ''}`}
                    src={prop.images[currentImageIndex]}
                    loading={"eager"}
                    onLoad={() => setLoading(false)}
                />
                {/* Icon with spin animation */}
                <img
                    alt={prop.title}
                    src={prop.icon}
                    className={`w-28 h-28 absolute z-10 bottom-4 right-4 transition-transform duration-300 ${isHovered || (isMobile && isInCenter) ? 'rotate-6' : ''}`}
                />
                {/* "More" button section with fade-in animation */}
                <motion.div
                    className="absolute bottom-0 inset-0 flex items-end justify-center"
                    initial={{opacity: 0}}
                    animate={isHovered || isMobile ? {opacity: 1} : {opacity: 0}}
                    transition={{duration: 0.5, delay: 0.3}} // Delay to ensure it appears after the spin
                >
                    <div className="w-full p-2 bg-black bg-opacity-70 flex items-start flex-col justify-center">
                        <div className={"flex flex-row"}>
                            <motion.h1
                                className="text-white text-2xl font-bold mr-4"
                                initial={{opacity: 0, y: 20}}
                                animate={isHovered || isMobile ? {opacity: 1, y: 0} : {opacity: 0, y: 20}}
                                transition={{duration: 0.3}}
                            >
                                {prop.title}
                            </motion.h1>
                        </div>
                        <AccessBtnComponent text="More"
                                            onClick={() => navigate(`/slot/${prop.id}`)}
                                            className="px-12 py-4 border-2 border-pink-700 rounded-xl text-white relative mt-6 text-lg font-semibold"/>
                    </div>
                </motion.div>
            </motion.div>
        </motion.section>
    );
}
